export enum Repeat {
  NOREPEAT = 0,
  EVERYWORKDAY = 1,
  EVERYDAY = 2,
  EVERYWEEK = 3,
  EVERYTWOWEEK = 4,
  EVERYMONTH = 5,
  EVERYYEAR = 6
}

export function getRepeatName(type: Repeat) {
  switch (type) {
    case Repeat.NOREPEAT:
      return "no-repeat";
    case Repeat.EVERYWORKDAY:
      return "Every working day";
    case Repeat.EVERYDAY:
      return "Every day";
    case Repeat.EVERYWEEK:
      return "Every week";
    case Repeat.EVERYTWOWEEK:
      return "Every two weeks";
    case Repeat.EVERYMONTH:
      return "Every month";
    case Repeat.EVERYYEAR:
      return "Every year";
    default:
      return "no-repeat";
  }
}

// 拖拽创建类型
export enum DragType {
  DRAGCREATE = 1,
  DRAGBLOCKEDIT = 2,
  DRAGBORDEREDIT = 3,
  DRAGTIMEBLOCKEDIT = 4 // 拖动日程忙闲时间块
}

// 拖拽视图类型
export enum DragViewType {
  WEEK = "week",
  DAY = "day",
  BUSYIDLE = "busyidle"
}

// 拖拽状态标志 down move up
export enum DragState {
  DOWN = "down",
  MOVE = "move",
  UP = "up"
}

// 编辑日程的方式
export enum TriggerType {
  DOUBLE = "double",
  DRAG = "drag"
}

// 获取数据范围 1:一个月，2:三个月
export enum OfflineRange {
  ONE = 1,
  TWO = 2
}
